"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isNumeric(value) {
    if (typeof value !== 'string' && typeof value !== 'number') {
        // The only possible numbers are string and number
        // Prevents any other data type, as a boolean, to be treated as a number
        return false;
    }
    if (typeof value === 'string' && value.trim() === '') {
        // Blank spaces must be considered as non numeric
        return false;
    }
    var num = Number(value);
    return !Number.isNaN(num) && Number.isFinite(num);
}
exports.default = isNumeric;
